import { Injectable } from '@angular/core';

interface EnumOption {
  ident: string;
  labelKey: string;
}

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  getEnumOptions(enumType: Record<string, string>, propertyPrefix: string): EnumOption[] {
    return Object.values(enumType).map((value) => ({
      ident: value,
      labelKey: `${propertyPrefix}.${value}`,
    }));
  }
}
